import { render } from "./OverlayFooter.vue?vue&type=template&id=40957fa6"
import script from "./OverlayFooter.vue?vue&type=script&lang=js"
export * from "./OverlayFooter.vue?vue&type=script&lang=js"

import "./OverlayFooter.vue?vue&type=style&index=0&id=40957fa6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__